enum GTMEventAction {
  Click = 'click',
}

export default GTMEventAction;
